import React from 'react';
import '../../css/designSystem/OutlinedLightButton.css';

const OutlinedLightButton = ({ text, onClick, type = "button" }) => {
  return (
    <button className="outlined-light-button" onClick={onClick} type={type}>
      <div className='help-text'>{text} </div>
    </button>
  );  
};

export default OutlinedLightButton;
